import {Component, ElementRef, Input, Self, ViewChild} from "@angular/core";
import {AbstractControl, ControlValueAccessor, NgControl} from "@angular/forms";
import {SvgIcon} from '@valg-shared/utils/svg-icon';

let NEXT_ID = 0;

@Component({
    selector: "valg-multi-input-file",
    templateUrl: "./multi-input-file.component.html",
})
export class MultiInputFileComponent implements ControlValueAccessor {
    @Input() errorKey?: string
    @Input() placeholder: string = "placeholder"
    id = `valg-multi-input-file-${NEXT_ID++}`;
    public SvgIcon = SvgIcon;

    constructor(@Self() private readonly ngControl: NgControl) {
        ngControl.valueAccessor = this;
    }

    get formControl() {
        return this.ngControl;
    }

    @ViewChild("input") inputElementRef!: ElementRef<HTMLInputElement>

    files: File[] = [];
    private onChange!: (value?: File[]) => void;
    private onTouched!: () => void;

    
    writeValue(obj: File): void {
        this.files.push(obj);
    }

    registerOnChange(fn: (value?: File[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    onClick() {
        this.inputElementRef.nativeElement.click()
        this.onTouched();
    }

    removeFile(index: number) {
        this.files.splice(index, 1);
        this.onChange(this.files);
      }

    onInputChange(event: any) {
        if (event.target.files) {
            for (let file of event.target.files) {
                this.files.push(file);
            }
            this.onChange(this.files);
            event.target.value = '';
        }
    }

    public static CreateFileFormatOrSizeValidator(fileTypes: string[], maxFileSize: number = 0) {
        return (control: AbstractControl) => {
            if (control.value) {
                const files = (control.value as File[])
                const isAnyFileInvalid = files.some(file => (file != null && !fileTypes.includes(file.type)) || (file != null && (maxFileSize == 0 || file.size >= maxFileSize )))
                return isAnyFileInvalid ? {invalid_file_format: true} : null;
            }
            return null;
        };
    }
    
    onReset()
    {
        this.inputElementRef.nativeElement.value = '';
    }
}
